// chart settings

export const CHART_SETTINGS_OUTPUT = 'output';
export const CHART_SETTINGS_OUTPUT_GROWTH = 'growth';

export const CHART_SETTINGS_SCALE = 'scale';
export const SCALE_DAILY = 'daily';
export const SCALE_WEEKLY = 'weekly';
export const SCALE_MONTHLY = 'monthly';
export const SCALE_MONTH_TO_DATE = 'monthToDate';
export const SCALE_QUARTERLY = 'quarterly';

export const CHART_SETTINGS_LOOKBACK_MODE = 'lookbackMode';
export const CHART_SETTINGS_TREND = 'trend';
export const CHART_SETTINGS_INCLUDE_CHANGE_RATE = 'includeChangeRate';
export const CHART_SETTINGS_CHANGE_RATE_MODE = 'changeRateMode';
export const CHART_SETTINGS_CHART_GROUPING = 'chartGrouping';

export const CHART_SETTINGS_WEEK_START_DAY = 'scaleWeekStart';
export const START_DAY_MON = 'monday';
export const START_DAY_TUE = 'tuesday';
export const START_DAY_WED = 'wednesday';
export const START_DAY_THU = 'thursday';
export const START_DAY_FRI = 'friday';
export const START_DAY_SAT = 'saturday';
export const START_DAY_SUN = 'sunday';

export const scaleOptions = [
  { name: 'Daily', id: SCALE_DAILY },
  { name: 'Weekly', id: SCALE_WEEKLY },
  { name: 'Monthly', id: SCALE_MONTHLY },
  {
    name: 'Month to date',
    id: SCALE_MONTH_TO_DATE,
  },
  { name: 'Quarterly ', id: SCALE_QUARTERLY },
];

export const depositsAggregationOptions = [
  { name: 'Period To date', id: '0' },
  { name: 'By Deposit date', id: '1' },
  { name: 'By Reg date (Day 0)', id: '2' },
];

export const weekStartOptions = [
  { id: START_DAY_MON, name: 'Mon' },
  { id: START_DAY_TUE, name: 'Tue' },
  { id: START_DAY_WED, name: 'Wed' },
  { id: START_DAY_THU, name: 'Thu' },
  { id: START_DAY_FRI, name: 'Fri' },
  { id: START_DAY_SAT, name: 'Sat' },
  { id: START_DAY_SUN, name: 'Sun' },
];

export const lookbackOptions = [
  { name: 'Day', id: '0' },
  { name: '3 days', id: '4' },
  { name: '7 days', id: '1' },
  { name: '10 days', id: '2' },
  { name: '30 days', id: '3' },
];

export const outputOptions = [
  { name: 'Value', id: 'values' },
  { name: 'Growth', id: 'growth' },
];

export const changeRateOptions = [
  { name: 'Default', id: 'default' },
  { name: 'Difference', id: 'difference' },
];
